import './App.css';
import React from 'react';
import { Route, Routes, BrowserRouter as Router, withRouter } from "react-router-dom";
import Home from './components/Home'
import Artists from './components/Artists'
import Nav from './components/Nav';
import { useEffect } from 'react';
import Ad from './components/Ad';

function App() {

  return (
    <div className="App">
      <Nav />
      {/* <Router> */}
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/artists' element={<Artists/>} />
        </Routes>
      <Ad />
      {/* </Router> */}
    </div>
  );
}

export default App;
